import axios from "axios";
import qs from "qs";
import { axiosConfig } from '@/config/config';
import ajax2 from "@/common/jqajax.js"

function ajax(options, ajaxCancel) {

    var optionsInside = {}

    for (var i in options) {
        if (i == "success") {
            continue
        }
        if (i == "error") {
            continue
        }
        optionsInside[i] = options[i]
    }

    var CancelToken = axios.CancelToken;

    optionsInside.url = axiosConfig.baseUrl + options.url;

    optionsInside.timeout = 6000;

    optionsInside.data ? optionsInside.data = qs.stringify(optionsInside.data) : {};

    axios({
        ...optionsInside,
        cancelToken: new CancelToken(function executor(c) {
            if (typeof (ajaxCancel) !== "undefined") {
                ajaxCancel = c;
            }
        }),
    })
        .then(r => {
            options.success && options.success(r.data)
        })
        .catch(e => {
            options.error && options.error(e)
        });

}

function post(options, ajaxCancel) {
    var optionsInside = {}

    for (var i in options) {
        if (i == "success") {
            continue
        }
        if (i == "error") {
            continue
        }
        if (i == "data") {
            continue
        }
        if (i == "url") {
            continue
        }
        optionsInside[i] = options[i]
    }

    var CancelToken = axios.CancelToken;

    options.url = axiosConfig.baseUrl + options.url;

    axios.post(options.url, options.data, {
        ...optionsInside,
        cancelToken: new CancelToken(function executor(c) {
            if (typeof (ajaxCancel) !== "undefined") {
                ajaxCancel = c;
            }
        }),
    })
        .then(r => {
            options.success && options.success(r.data)
        })
        .catch(e => {
            options.error && options.error(e)
        });
}
export {
    ajax,
    post,
    ajax2
}


// WEBPACK FOOTER //
// ./src/common/ajax.js